export default "__VITE_ASSET__BPbvd7q4__"